import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase/config.js';
import { doc, getDoc, deleteDoc } from 'firebase/firestore';
import { readRetakeSubmissions } from '../control/RetakeSubmissionData.js';
import CancelAppointmentUI from '../ui/CancelAppointmentUI';

const CancelAppointmentSite = () => {
    const [appointments, setAppointments] = useState([]);
    const [currentUserEmail, setCurrentUserEmail] = useState(null);
    const [selectedAppointments, setSelectedAppointments] = useState([]);

    useEffect(() => {
        const user = auth.currentUser;
        if (user) {
            const userDocRef = doc(db, "users", user.uid);
            getDoc(userDocRef).then(docSnapshot => {
                if (docSnapshot.exists()) {
                    const data = docSnapshot.data();
                    setCurrentUserEmail(data.email);
                    console.log(currentUserEmail);
                }
            }).catch(error => {
                console.error("Error fetching user data: ", error);
            });
        }
    }, []);

    const fetchAppointments = async () => {
        const submissions = await readRetakeSubmissions();

        const filteredAppointments = submissions.filter(submission => submission.email === currentUserEmail);
      
        setAppointments(filteredAppointments);
    };

    useEffect(() => {
        fetchAppointments();
    }, [currentUserEmail]);

    const handleSubmit = async () => {
        if (selectedAppointments.length > 0) {
            try {
                // Loop through selected appointments and delete them
                for (let appointment of selectedAppointments) {
                    await deleteDoc(doc(db, 'retakeSubmissions', appointment.id));
                    console.log(`Canceled appointment: ${appointment.name}`);
                }
                // Remove canceled appointments from the UI
                setAppointments(appointments.filter(appointment => !selectedAppointments.some(sel => sel.id === appointment.id)));
                setSelectedAppointments([]); // Clear selection after deletion
            } catch (error) {
                console.error("Error canceling appointment: ", error);
            }
        } else {
            alert('Please select at least one appointment to cancel.');
        }
    };

    return (
        <CancelAppointmentUI
            appointments={appointments}
            selectedAppointments={selectedAppointments}
            setSelectedAppointments={setSelectedAppointments}
            handleSubmit={handleSubmit}
        />
    );
};

export default CancelAppointmentSite;
